// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__uGgY8","disabled":"FileBtn_disabled__1BcGu","warn":"FileBtn_warn__2Icj4","fade":"FileBtn_fade__1PYrx"};